import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";
import { connect } from "react-redux";
import ActionsBar from "../components/ActionsBar/";
import Header from "../components/Header/";
import { setNavigatorPosition } from "../state/store";

const styles = theme => ({});

class Blog extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    navigatorPosition: PropTypes.string.isRequired,
    setNavigatorPosition: PropTypes.func.isRequired,
    isWideScreen: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
  };

  categories = [];

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    if (this.props.navigatorPosition !== "is-featured") {
      this.props.setNavigatorPosition("is-featured");
    }
    //this.getCategories();
  }

  getCategories = () => {
    this.categories = this.props.data.posts.edges.reduce((list, edge, i) => {
      const category = edge.node.frontmatter.category;
      if (category && !~list.indexOf(category)) {
        return list.concat(edge.node.frontmatter.category);
      } else {
        return list;
      }
    }, []);
  };

  render() {
    const { data } = this.props;
    /*const {
      pages: { edges: pages }
    } = data;*/

    return (
      <React.Fragment>
        <Header
          path={this.props.location.pathname}
          isSubView={true}
          pages={[]}
          isWideScreen={this.props.isWideScreen}
        />
        {/*<Navigator posts={data.posts.edges} navigatorPosition="is-featured" />*/}
        <ActionsBar categories={this.categories} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    pages: state.pages,
    navigatorPosition: state.navigatorPosition,
    isWideScreen: state.isWideScreen
  };
};

const mapDispatchToProps = {
  setNavigatorPosition
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectSheet(styles)(Blog));

//eslint-disable-next-line no-undef
export const guery = graphql`
  query BlogQuery {
    pages: allMarkdownRemark(
      filter: { id: { regex: "//pages//" }, fields: { prefix: { regex: "/^\\d+$/" } } }
      sort: { fields: [fields___prefix], order: ASC }
    ) {
      edges {
        node {
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            menuTitle
          }
        }
      }
    }
    footnote: markdownRemark(id: { regex: "/footnote/" }) {
      id
      html
    }
    parts: allMarkdownRemark(filter: { id: { regex: "//parts//" } }) {
      edges {
        node {
          html
          frontmatter {
            title
          }
        }
      }
    }
  }
`;
/* insert to queries after blog is present
posts: allMarkdownRemark(
      filter: { id: { regex: "//posts//" } }
      sort: { fields: [fields___prefix], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            subTitle
            category
            cover {
              children {
                ... on ImageSharp {
                  resolutions(width: 90, height: 90) {
                    ...GatsbyImageSharpResolutions_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
*/



// WEBPACK FOOTER //
// ./src/pages/blog.js